import { render, staticRenderFns } from "./soinfo.vue?vue&type=template&id=5ecc3fff&scoped=true&"
import script from "./soinfo.vue?vue&type=script&lang=js&"
export * from "./soinfo.vue?vue&type=script&lang=js&"
import style0 from "./soinfo.vue?vue&type=style&index=0&id=5ecc3fff&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecc3fff",
  null
  
)

export default component.exports